import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OrdersCountMetadata } from '@compumark/order-management-client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { OrderSelectionService } from '../selection/order-selection.service';
import { NavigationBarService } from '../services/navigation-bar/navigation-bar.service';
import { OrdersApiClientService } from '../services/orders.api.client.service';

@Component({
  selector: 'app-action-bar',
  templateUrl: './action-bar.component.html',
  styleUrls: ['./action-bar.component.scss'],
  standalone: false,
})
export class ActionBarComponent {
  private route = inject(ActivatedRoute);
  private orderSelectionService = inject(OrderSelectionService);
  private ordersApiClientService = inject(OrdersApiClientService);
  private navigationBarService = inject(NavigationBarService);

  public ordersCountMetadata: OrdersCountMetadata;

  constructor() {
    this.ordersCountMetadata = this.route.snapshot.data.ordersCountMetadata;
  }
  get disabled(): boolean {
    return this.orderSelectionService.selectedRowsCountChange$.getValue() < 1;
  }

  getSelectedCount(): number {
    return this.orderSelectionService.selectedRowsCountChange$.getValue();
  }

  get activeTab(): string {
    return this.ordersApiClientService.getActiveTab();
  }

  public openSideNav(): void {
    this.navigationBarService.show(true);
  }

  public isSideNavClosed(): Observable<boolean> {
    return this.navigationBarService.sideNavBar$.pipe(
      map((sideNavOpen) => !sideNavOpen),
    );
  }
}
